;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.product-pack.show')
    .controller('ProductPackShowController', ProductPackShowController)

  ProductPackShowController.$inject = [
    // Angular
    '$state', '$uibModal',

    // Managers
    'ProductManager',

    // Services
    'SnackService', 'DisplayService',

    // Resolve
    'productPack'
  ]

  function ProductPackShowController (
    $state, $uibModal,
    ProductManager,
    SnackService, DisplayService,
    productPack
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        productPack: productPack,

        save: save,
        remove: remove,
        addProduct: addProduct,
        removeProduct: removeProduct,
        openProductSearch: openProductSearch
      })

      init()
    }

    function init () {
      self.productPack.products = self.productPack.products || []
    }

    function openProductSearch () {
      $uibModal.open({
        size: 'xl',
        controllerAs: 'addLine',
        bindToController: true,
        templateUrl: '/app/common/services/line/modals/add-line/add-line.template.html',
        controller: ['$scope', '$uibModalInstance', 'ProductManager', 'FilterService', 'PaginationModel',
          function ($scope, $uibModalInstance, ProductManager, FilterService, PaginationModel) {
            var modal = this
            var pagination = PaginationModel.getRaw()
            // Retire le watcher $rootScope de la pagination à la fermeture de la modale
            $scope.$on('$destroy', function () { pagination.destroy() })

            _.extend(modal, {
              products: [],
              outBpu: false,
              grant: false,
              step: 1,
              invoice: {},
              pagination: pagination,
              groupFind: FilterService.groupFind,
              selectProduct: selectProduct,
              cancel: cancel,
              getList: getList,
              clearSearch: clearSearch,
              addCriteria: addCriteria,
              sort: sort,
              searchProductRef: searchProductRef,
              searchProductLabel: searchProductLabel,
              searchProductCategory: searchProductCategory,
              searchTags: searchTags
            })

            getList()

            function selectProduct (product) {
              $uibModalInstance.close(product)
            }

            function cancel () {
              $uibModalInstance.dismiss('cancel')
            }

            function getList () {
              pagination.search = FilterService.sanitizeSearchTree(pagination.search, true)
              pagination.orderBy = pagination.orderBy || '-createdAt'

              var hasArchived = pagination.search && FilterService.hasArchivedCriteria(pagination.search)
              if (!hasArchived) {
                addCriteria('isArchived', { _id: 'archived', value: 'false' })
                return
              }

              var query = ProductManager
                .query({ populate: JSON.stringify([{ path: 'tags' }, { path: 'type' }]) })
                .paginate(pagination.toQueryOptions())

              if (pagination.search) {
                query.setQuery(FilterService.parseQueryTree(pagination.search))
              }

              ProductManager.post(query).then(function (data) {
                modal.products = data.data
                pagination.totalElements = data.meta.total
                if (parseInt(data.meta.total) !== 0 && !data.data.length) {
                  pagination.currentPage = 0
                  getList()
                }
              })
            }

            function addCriteria (key, value) {
              if (value !== undefined && value !== null) {
                pagination.search = FilterService.addCriteria(pagination.search, key, value)
                getList()
              }
            }

            function clearSearch () {
              pagination.search = {}
              getList()
            }

            function sort (name) {
              pagination.reverse = (pagination.orderBy === name) ? !pagination.reverse : false
              pagination.orderBy = name
              getList()
            }

            function searchProductRef (search) {
              return FilterService.searchProductRef(search).then(function (refs) {
                modal.refs = refs
              })
            }

            function searchProductLabel (search) {
              return FilterService.searchProductLabel(search).then(function (labels) {
                modal.labels = labels
              })
            }

            function searchProductCategory (search) {
              return ProductManager.get(
                ProductManager.query({ sort: 'category', distinct: 'category' })
                  .paginate({ limit: 20 })
                  .search(search, 'category')
              ).then(function (data) {
                modal.searchCategories = _.take(data.data, 20).map(function (d) {
                  return { origin: new RegExp('^' + search + '.*', 'i').test(d) ? 'precise' : 'simple', _id: d, v: d }
                })
              })
            }

            function searchTags (query) {
              return FilterService.searchTags(query).then(function (tags) {
                modal.tags = tags
              })
            }
          }
        ]
      }).result.then(function (product) {
        addProduct(product)
      })
    }

    function addProduct (product) {
      if (!product) return
      var alreadyIn = _.find(self.productPack.products, function (item) {
        return _.get(item, 'product._id') === product._id || _.get(item, 'product') === product._id
      })
      if (alreadyIn) {
        SnackService.snack({ text: 'Ce produit est déjà dans le pack.', delay: 3000 })
        return
      }
      self.productPack.products.push({ product: product, quantity: 1 })
      self.productPackForm.$dirty = true
    }

    function removeProduct (index) {
      self.productPack.products.splice(index, 1)
      self.productPackForm.$dirty = true
    }

    function save () {
      productPack.save().then(function () {
        SnackService.snack({ text: 'Pack produits sauvegardé !', delay: 5000 })
        if ($state.is('product-pack.new')) {
          $state.go('product-pack.list')
        } else {
          $state.reload()
        }
      })
    }

    function remove () {
      DisplayService.confirmDeletion().then(function () {
        productPack.archive().then(function () {
          SnackService.snack({ text: 'Pack produits supprimé !', delay: 5000 })
          $state.go('product-pack.list')
        })
      })
    }
  }
})(window.angular, window._)
